import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useAtomValue } from 'jotai';
import { ArticleTitle } from '../../../../../../title';
import { pathnameUrlLanguageAtom, ValidSections } from '../../../../../../../../../../history';
import { FeatureArticleTextContainer } from './components';
import { useLocalizedSanityNewsListWithSearchTermAndLimitsByPrimaryDimensionSlug } from '../../../../../../../../../../sanity';

export const FeatureArticleText = () => {
  const locale = useAtomValue(pathnameUrlLanguageAtom);
  const {
    data,
  } = useLocalizedSanityNewsListWithSearchTermAndLimitsByPrimaryDimensionSlug();
  const {
    slug,
  } = data ?? {};
  return (
    <FeatureArticleTextContainer>
      <ouiDom.A.A
        to={`/${locale}/${ValidSections.NEWS}/${slug}`}
        flexGrow={1}
        display={ouiStyle.Constants.DisplayProp.flex}
        alignItems={ouiStyle.Constants.AlignItemsProp.start}
        justifyContent={ouiStyle.Constants.JustifyContentProp.center}
        color={ouiStyle.Constants.Colors.inverted}
        lineFactor={[2, undefined, undefined, undefined, 3, undefined]}
        fontWeight={ouiStyle.Constants.FontWeightProp.bold}
        paddingVertical="none"
      >
        <ArticleTitle />
      </ouiDom.A.A>
    </FeatureArticleTextContainer>
  );
};
